import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-offer-pop-up',
  templateUrl: './offer-pop-up.component.html',
  styleUrls: ['./offer-pop-up.component.css']
})
export class OfferPopUpComponent implements OnInit {

  @Input() offer;
  HideOfferName: any;
  OfferName = 'Offer';

  constructor() { }

  ngOnInit() {
  }

formatCurrencyINR(value: number, currencyCode: string = 'INR', symbolDisplay: boolean = true): string {
    if (value === null || value === undefined) return null;
  
    // Manually format the number with Indian grouping
    let formattedValue = Number(value).toFixed(2); // Ensures 2 decimal places
    let parts = formattedValue.split('.');
  
    let integerPart = parts[0];
    let decimalPart = parts.length > 1 ? '.' + parts[1] : '';
  
    // Regex to format the integer part with commas in the Indian numbering system
    let lastThreeDigits = integerPart.substring(integerPart.length - 3);
    let otherDigits = integerPart.substring(0, integerPart.length - 3);
  
    if (otherDigits !== '') {
      lastThreeDigits = ',' + lastThreeDigits;
    }
  
    let regex = /\B(?=(\d{2})+(?!\d))/g;
    let formattedIntegerPart = otherDigits.replace(regex, ',') + lastThreeDigits;
  
    let currencySymbol = currencyCode === 'INR' ? '₹' : currencyCode;
  
   // return symbolDisplay ? `${currencySymbol}${formattedIntegerPart}${decimalPart}` : `${formattedIntegerPart}${decimalPart}`;
   return symbolDisplay ? `${currencySymbol}${formattedIntegerPart}` : `${formattedIntegerPart}`;
  }

}



// WEBPACK FOOTER //
// ./src/app/calculators/home-loan-comparison-calculator/offer-pop-up/offer-pop-up.component.ts